export enum PlatformID {
    DESKTOP = 0,
    MOBILE = 1,
    ANDROID = 2,
    IOS = 3,
}
